import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PedidosService } from '../services/pedidos.service';
import { Pedido } from '../models/pedido.model';
import { HttpErrorResponse } from '@angular/common/http';
import { SnackbarService } from '../../../shared/services/snackbar.service';
import { PedidosListaComponent } from '../components/pedidos-lista/pedidos-lista.component';
import { SocketService } from 'src/app/shared/services/socket.service';
import { Notification } from '../../../shared/models/notification.model';

@Component({
  selector: 'app-pedidos-view',
  templateUrl: './pedidos-view.component.html',
  styleUrls: ['./pedidos-view.component.scss'],
})
export class PedidosViewComponent implements OnInit {
  public filtro: string = '';
  public pedidos: Pedido[] = [];
  @ViewChild(PedidosListaComponent)
  pedidosListaComponent!: PedidosListaComponent;

  constructor(
    private router: Router,
    private pedidosService: PedidosService,
    private snackbarService: SnackbarService,
    private socketService: SocketService,
  ) {}

  ngOnInit(): void {
    this.obtenerListadoDePedidos();

    this.socketService.connect();
    this.suscribirseASockets();
    this.listenPedidosRealtime();
  }

  private suscribirseASockets(): void {
    this.socketService.nuevaOrden$.subscribe((res: Notification) => {
      this.obtenerListadoDePedidos();
    });

    this.socketService.cambioEstadoPedido$.subscribe((res) => {
      console.log('Pedido actualizado');
    });
  }

  private obtenerListadoDePedidos(): void {
    this.pedidosService.obtenerListadoDePedidos().subscribe(
      (res) => {
        this.pedidos = res;
      },
      (error: HttpErrorResponse) => {
        this.snackbarService.error('Error', error.message, 5000);
      },
    );
  }

  private listenPedidosRealtime(): void {
    this.socketService.nuevaOrden$.subscribe((nuevaOrden) => {
      this.onNuevaOrden(nuevaOrden);
    });
  }

  private onNuevaOrden(nuevaOrden: any): void {
    this.pedidos = [nuevaOrden, ...this.pedidos];
  }

  public aplicarFiltro() {}

  public limpiarFiltro() {
    this.filtro = '';
    this.aplicarFiltro();
  }

  public agregarPedido() {
    this.router.navigate(['/admin/pedidos/crear']);
  }

  public obtenerChangeEmisor(): void {
    this.obtenerListadoDePedidos();
  }
}
